module.exports = __webpack_public_path__ + "static/media/eje_galvanizado.a2ead65f.jpg";